import {useCallback} from 'react';

import {useIsInLoadedReportContext} from '../../pages/ReportPage/LoadedReportContext';
import {makeTrackEvent} from '../../services/analytics/makeTrackEvent';

export type FilterLocation = 'workspace' | 'report';

type FilterGroupCreatedEvent = {
  location: FilterLocation;
};

type FilterORToggledEvent = {
  location: FilterLocation;
};

export const trackFilterGroupCreated = makeTrackEvent<
  FilterGroupCreatedEvent,
  {
    location: {
      description: 'where the filter group was created';
    };
    _description: 'Tracks when a user creates a new filter group';
    _location: 'workspaces, reports';
    _motivation: 'track AND/OR filter feature adoption';
  }
>('Filter group created', {shouldLogToConsole: true});

export const trackFilterORToggled = makeTrackEvent<
  FilterORToggledEvent,
  {
    location: {
      description: 'where the OR connector was toggled';
    };
    _description: 'Tracks when a user toggles a filter connector to OR';
    _location: 'workspaces, reports';
    _motivation: 'track AND/OR filter feature adoption';
  }
>('Filter OR toggled', {shouldLogToConsole: true});

export const useTrackFilterWithLocation = () => {
  const isReport = useIsInLoadedReportContext();
  const location: FilterLocation = isReport ? 'report' : 'workspace';

  const trackGroupCreated = useCallback(() => {
    trackFilterGroupCreated({location});
  }, [location]);

  const trackORToggled = useCallback(() => {
    trackFilterORToggled({location});
  }, [location]);

  return {trackGroupCreated, trackORToggled};
};
